// ── Native plain-notification sync (Android) ─────────────────────────────────
// Same idea as alarmSync.js, but for reminderType !== "alarm" items: schedules
// AlarmManager wake-ups (via NotificationScheduler, no exact-alarm permission
// needed) so plain reminder notifications fire even with the app fully
// closed.
import { useEffect, useRef } from 'react';
import { registerPlugin, Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';
import { collectUpcomingNotifications } from '../utils/taskLogic';
import { collectUpcomingHabitNotifications } from '../utils/habitLogic';

const NotificationScheduler = registerPlugin('NotificationScheduler');
const isNative = Capacitor.isNativePlatform();

function syncNotifications(tasks, calEvents, calReminders, taskOccurrenceOverrides, calEventOccurrenceOverrides, habits, habitLogs, habitSkips) {
  const items = [
    ...collectUpcomingNotifications({ tasks, calEvents, calReminders, taskOccurrenceOverrides, calEventOccurrenceOverrides }),
    ...collectUpcomingHabitNotifications({ habits, habitLogs, habitSkips }),
  ];
  const payload = JSON.stringify({ items });
  NotificationScheduler.scheduleAll({ json: payload }).catch(() => {});
}

export function useNotificationSync(tasks, calEvents, calReminders, taskOccurrenceOverrides, calEventOccurrenceOverrides, habits = [], habitLogs = {}, habitSkips = []) {
  const debounceRef = useRef(null);

  useEffect(() => {
    if (!isNative) return;
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      syncNotifications(tasks, calEvents, calReminders, taskOccurrenceOverrides, calEventOccurrenceOverrides, habits, habitLogs, habitSkips);
    }, 800);
    return () => clearTimeout(debounceRef.current);
  }, [tasks, calEvents, calReminders, taskOccurrenceOverrides, calEventOccurrenceOverrides, habits, habitLogs, habitSkips]);

  useEffect(() => {
    if (!isNative) return;
    const sub = CapacitorApp.addListener('appStateChange', ({ isActive }) => {
      if (isActive) syncNotifications(tasks, calEvents, calReminders, taskOccurrenceOverrides, calEventOccurrenceOverrides, habits, habitLogs, habitSkips);
    });
    return () => { sub.then((h) => h.remove()).catch(() => {}); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
